import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import {
    Grid,
} from '@mui/material';
import { Button, Input, Form } from 'Components';
import { Alert } from '@mui/material';
import TagsManage from 'Modules/.common/components/TagsManage';
import { NotificationManager } from 'Components/Notifications';

// Components
import DragDropList from 'Components/DragDropList';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import QuestionCreateEdit from './questionCreateEdit'

import {
    openFormCreateEdit,
    createFormSettings,
    updateFormSettings,
    searchFormSettings,
    clearRedux
} from 'Redux/actions';

const isValidTag = (t) => t && Number.isFinite(+t.id) && +t.id > 0;
const filterOutSpecial = (tags = []) => tags.filter(isValidTag);

const FormCreateEdit = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({});
    const [questions, setQuestions] = useState([]);
    const [error, setError] = useState('');
    const [dragDisabled, setDragDisabled] = useState(false);
    //Selectors
    const {
        openCreateEditForm,
        response,
        form,
        loadingCreateEdit
    } = useSelector(state => state.fsmSettingsRedux);


    useEffect(() => {
        if (response?.error === false) {
            let messageNotification = (form?.name) ? messages['fsm_settings_form_update_success'] : messages['fsm_settings_form_create_success'];
            NotificationManager.success(
                messageNotification,
                messages['success'],
                3000,
                null,
                null,
                'Success',
            );
            handleClose();
        }
    }, [response]);

    const handleClose = useCallback(() => {
        setFormData({});
        setQuestions([]);
        setError('');
        setDragDisabled(false);
        dispatch(clearRedux("FSM_SETTINGS_FORM", {
            openCreateEditForm: false,
            loadingCreateEdit: false,
            response: {},
            form: {}
        }));

        if (props.callBack) props.callBack(); 
        
        dispatch(openFormCreateEdit(false));
    });

    useEffect(() => {
        if (form?.name) {
            setFormData({
                name: form?.name,
                tags: filterOutSpecial(form?.tags || [])
            });


            const newQuestions = form?.questions?.map((question, i) => {
                let newAnswer = [];

                question?.answers?.forEach((answer, r) => {
                    newAnswer.push({
                        id: answer.id,
                        name: answer.name,
                        priority: answer.priority,
                        keys: r
                    })
                });

                return {
                    ...question,
                    answers: newAnswer,
                    priority: i + 1,
                    key: i
                };
            })

            if (newQuestions?.length > 0)
                setQuestions(newQuestions)
        }
    }, [form]);

    const onSubmit = useCallback(() => {

        if (!formData?.name) {
            setError(messages['fsm_settings_form_nameRequired']);
            return false;
        }

        const cleanedTags = filterOutSpecial(formData?.tags || []);
        if (!cleanedTags.length) {
            setError(messages['fsm_settings_form_tagsRequired']);
            return false;
        }

        const newTags = Array.from(new Set(cleanedTags.map(tag => +tag.id)));

        let newQuestions = [];
        let error = false;
        let message = messages['fsm_settings_form_questionsRequired'];
        questions?.forEach((question, k) => {
            let newAnswer = [];
            if (!question?.name) {
                error = true;
                return false;
            }

            const questionsValidation = newQuestions?.filter(q => q?.name === question?.name);
            if (questionsValidation.length > 0) {
                error = true;
                message=messages['fsm_settings_form_error_question_duplicate'];
                return false;
            }

            question?.answers?.forEach((answer, i) => {
                newAnswer.push({
                    id: answer?.id,
                    name: answer.name,
                    priority: i
                })
            });

            newAnswer.reverse();

            newQuestions.push({
                id: question.id,
                name: question.name,
                priority: k,
                answers: newAnswer
            })

        });

        if (error) {
            setError(message);
            return false;
        }


        if (form?.name) {
            dispatch(updateFormSettings({
                id: form?.id,
                name: formData?.name,
                tagIds: newTags,
                questions: newQuestions
            }))
        } else {
            dispatch(createFormSettings({
                name: formData?.name,
                tagIds: newTags,
                questions: newQuestions
            }))
        }

    });

    const array_move = (arr, old_index, new_index) => {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };



    const changeDragDisabled = useCallback((action) => {
        setDragDisabled(action)
    });

    const DeleteQuestion = useCallback((item) => {
        const newQuestions = questions?.filter(q => q.key !== item.key);
        const resultArray = newQuestions.map((question, cont) => {
            return {
                ...question,
                priority: cont + 1,
            };
        });

        setQuestions(resultArray);
    });

    const updateQuestion = (elemento) => {
        const newQuestion = questions.map(question => {
            return (elemento.key === question.key) ? elemento : question;
        })

        setQuestions(newQuestion)
    };

    let title = (form?.name) ? `${messages['fsm_settings_form_edit']} ${form?.name}` : messages['fsm_settings_form_new'];
    return (
        <Modal
            title={title}
            open={openCreateEditForm}
            loading={loadingCreateEdit}
            size={`small`}
            handleClose={() => handleClose()}
            position="right"
        >
            <ModalBody style={{ overflow: 'hidden', padding: 10,height: 'calc(100vh - 190px)', overflowX:'hidden',overflowY: 'scroll' }}>
                <div >
                    {
                        error &&
                        <Alert severity="error">{error}</Alert>
                    }
                    <Grid
                        container
                        justifyContent={'center'}
                        direction={'column'}
                        className="paddingBody"
                        spacing={2}
                    >
                        <Grid item xs={12} >
                            <Input
                                id="name"
                                type="text"
                                label={messages['fsm_settings_form_name']}
                                placeholder={messages['fsm_settings_form_name']}
                                value={formData.name || ""}
                                onChange={(value) => setFormData({ ...formData, name: value })}
                                required
                                requiredMessage={messages['required_field']}
                                maxLength={30}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TagsManage
                                onlyTags={true}
                                mode="selector"
                                enableSelectAll={false}
                                disableUntaggedSelection={true}
                                height={120}
                                label={messages["vehicleView_tags"]}
                                placeholder={messages["vehicleView_tags"]}
                                value={filterOutSpecial(formData?.tags || [])}
                                onChange={(items) => {
                                    const cleaned = filterOutSpecial(items)
                                    setFormData({ ...formData, tags: cleaned })
                                }}
                                menuStyle={{ maxHeight: '280px', maxWidth: '445px' }}
                                isVisiblePill={true}

                            />
                        </Grid>
                        <Grid item xs={12}>
                            <label className="input-normal-label">{messages["fsm_settings_form_questions"]}</label>
                            <Button
                                id="addQuestions"
                                type="icon"
                                tooltip={messages["fsm_settings_form_addQuestion"]}
                                icon="add_box"
                                onClick={() => {
                                    let key = (questions.length > 0) ? Math.max.apply(undefined, questions.map((q) => q.key)) + 1 : 0;
                                    setQuestions([...questions, {
                                        name: '',
                                        key,
                                        priority: questions.length + 1,
                                        answers: []
                                    }]);
                                }}
                            />
                            <DragDropList
                                items={questions}
                                keyName="key"
                                isDragDisabled={!dragDisabled}
                                itemRenderer={(item) => {
                                    return <QuestionCreateEdit key={item.key} data={item} callback={updateQuestion} array_move={array_move} changeDragDisabled={changeDragDisabled} DeleteQuestion={DeleteQuestion} />;
                                }}
                                onDragEnd={(result) => {
                                    const newQuestion = array_move([...questions], result.source.index, result.destination.index);
                                    const resultArray = newQuestion.map((q, cont) => {
                                        return {
                                            ...q,
                                            priority: cont + 1,
                                        };
                                    });

                                    setQuestions(resultArray)
                                }}
                            />
                        </Grid>

                    </Grid>
                </div>
            </ModalBody>
            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    className="btn-blue"
                    onClick={onSubmit}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default FormCreateEdit;